const CLIENT_ID_ONLINE = '684C957199C3BE6C153A778D1986032B';
export const MD_CLIENT_ID = 'consumer-travel';

export default CLIENT_ID_ONLINE;
